import React, { ReactNode } from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import { useTheme } from '@adsk/alloy-react-styles';

import { DROPZONE_SIZES, Size, sizePropType } from '../consts';

type DefaultActiveDragContentProps = {
  size?: Size;
  text?: ReactNode;
};

const DefaultActiveDragContent = React.forwardRef<
  HTMLDivElement,
  DefaultActiveDragContentProps
>(({ size, text }, ref) => {
  const theme = useTheme();
  const dragTextTokens =
    theme.tokens?.component?.dropzone?.['drag-active-text'];
  const textStyles =
    size === DROPZONE_SIZES.SMALL
      ? dragTextTokens?.small
      : dragTextTokens?.default;
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <div ref={ref} css={[textStyles]}>
      {text || T.translate('DROP_FILES_TO_UPLOAD')}
    </div>
  );
});

DefaultActiveDragContent.displayName = 'DefaultActiveDragContent';

DefaultActiveDragContent.propTypes = {
  /** Dropzone size */
  size: sizePropType,
};

export default DefaultActiveDragContent;
